/**
 * Implements a styled dropdown list
 */
import './styles.scss';

interface IListProps {
    className: string;
    children: React.ReactChild | React.ReactChild[];
}

/**
 * List holder
 * @param props
 * @returns
 */
const List = (props: IListProps) =>
  <div className={`dropdown__list ${props.className}`}>{props.children}</div>;



interface IItemProps {
    children: React.ReactChild | React.ReactChild[];
}
/**
 * List item
 */
const Item = (props: IItemProps) =>
  <div className='dropdown__list__item'>{props.children}</div>;

export {
  List,
  Item
};